<template>
  <div class="signup-verify-email">
    <div class="heading-4 black--text">
      Sign up. <br />
      Verify your email.
    </div>
    <div class="mt-8">
      <form @submit.prevent="submit">
        <div class="d-flex flex-column flex-sm-row">
          <div class="d-flex flex-1">
            <v-text-field
              outlined
              single-line
              v-for="index in [0, 1, 2, 3]"
              :key="index"
              v-model="codes[index]"
              :class="['code-input', { 'ml-3': index }]"
              :autofocus="!index"
              @input="onCodeChanged($event, index - 10)"
              @keyup="onBackspacePressed($event, index - 10)"
              :tabindex="index - 10"
              :hide-details="true"
            ></v-text-field>
          </div>
          <div class="d-flex flex-1 mt-3 mt-sm-0">
            <v-text-field
              outlined
              single-line
              v-for="index in [4, 5, 6, 7]"
              :key="index"
              v-model="codes[index]"
              :class="[
                'code-input',
                { 'ml-3': index > 4, 'ml-sm-3': index === 4 },
              ]"
              :autofocus="!index"
              @input="onCodeChanged($event, index - 10)"
              @keyup="onBackspacePressed($event, index - 10)"
              :tabindex="index - 10"
              :hide-details="true"
            ></v-text-field>
          </div>
        </div>
        <div class="error--text mt-4" v-if="signupState.error">
          {{ signupState.error.message }}
        </div>
        <div class="mt-8 d-flex justify-center">
          <input type="submit" class="d-none" />
          <c-btn
            style="width: 234px"
            :disabled="!isFormValid"
            :loading="loading"
            @click="submit"
            >Verify</c-btn
          >
        </div>
        <div class="text-center mt-2">
          <a
            href="javascript:void(0)"
            @click="$emit('resend')"
            :loading="signupState.codeSending"
            class="text-6 primary--text text-decoration-none"
            >Resend verification code</a
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["loading"],
  data: () => ({
    codes: Array(8).fill(null),
  }),
  methods: {
    submit() {
      if (this.isFormValid) {
        this.$emit("submit", `${this.codes.join("")}`);
      }
    },
    focusInput(tabIndex) {
      const inputElem = document.querySelector(
        `.code-input [tabindex='${tabIndex}']`
      );
      inputElem && inputElem.focus();
    },
    onCodeChanged(value, tabIndex) {
      value = value.trim();
      value = value.replace("-", "");
      if (value.match(/^[0-9]{8}$/)) {
        return (this.codes = value.split(""));
      }
      if (value.match(/^[0-9]{1}$/)) {
        this.focusInput(tabIndex + 1);
      }
    },
    onBackspacePressed(e, tabIndex) {
      if (e.keyCode === 8) {
        this.$nextTick(() => {
          if (!e.target.value) {
            this.focusInput(tabIndex - 1);
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      signupState: "auth/signup",
    }),
    isFormValid() {
      return this.codes.join("").match(/^[0-9]{8}$/);
    },
  },
};
</script>

<style lang="scss">
.code-input {
  .v-input__slot {
    margin-bottom: 0 !important;
    min-height: 44px !important;
    padding: 0 16px !important;
    fieldset {
      border-radius: 5px;
    }
  }
  .v-text-field__details {
    display: none;
  }
  input {
    text-align: center;
  }
}
.btn-resend {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
